
import { defineComponent } from 'vue'
import { MemberAccess, useMemberModule } from '@/modules/members'
import { useRoute } from 'vue-router'
import ResourceLink from '@/components/_shared/links/resource-link.vue'
import { usePackageModule } from '@/modules/packages'

export default defineComponent({
    name: 'members-show-member-accesses-list',
    components: { ResourceLink },
    async setup () {
        const route = useRoute()
        const { getMemberAccesses } = useMemberModule()
        const { getPackageNameById, getPackages, packagesById } = usePackageModule()

        getPackages()

        const memberAccessesList = await getMemberAccesses(route.params.memberId as string)

        const resourceFormatter = function (row: MemberAccess) {
            return {
                type: row.resourceType,
                title: row.resourceType === 'agreement' ? row.agreementName : null
            }
        }

        const memberAccessesColumns = ([
            { name: 'resourceId', label: 'Resource Id', field: (row: MemberAccess) => getResourceObj(row), align: 'left' },
            { name: 'resource', label: 'Resource type', field: resourceFormatter, align: 'left' },
            { name: 'packages', label: 'Packages', field: 'packages', align: 'left' },
            { name: 'startDate', label: 'Start date', field: 'startDate', align: 'left' },
            { name: 'endDate', label: 'End date', field: 'endDate', align: 'left' }
        ])
        function getResourceObj (accessObj: MemberAccess) {
            return {
                id: accessObj.resourceId,
                type: accessObj.resourceType,
                alias: accessObj.packages.join(', ')
            }
        }

        function isPackageAvailable (packageId: string): boolean {
            return !!packagesById.value.get(packageId)
        }

        return {
            memberAccessesList,
            memberAccessesColumns,
            getPackageNameById,
            isPackageAvailable
        }
    }
})
